import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../css/dakehu.css';
import {withRouter,Link} from 'react-router-dom';
import phone from '../util/phone';
class Dakehusix extends Component{
    state={
        dakehuonem:'none',
        videoone:['https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/1.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/2.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/3.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/4.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/5.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/6.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/7.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/8.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/9.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/10.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/11.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/12.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/13.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/14.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/15.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/16.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/17.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/18.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/19.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/20.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/21.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/22.mp4','https://micro-weixun.oss-cn-beijing.aliyuncs.com/xiaoshou128/6/23.mp4'],
        videos:'',
        dakehusis:'block',
        dakehusixns:'none',
        shenqing:'none'
    }
    panduan(videonum){
        if(phone.indexOf(this.props.userInfo.userInfo.phone)==-1){
            this.setState({
                shenqing:'block'
            })
            return -1;
        }else{
            console.log('成功')
            this.setState({
                dakehuonem:'block',
                videos:videonum
            });
            return 2;
        }
    }
    firstm(){
       var videonum=this.state.videoone[0];
        this.panduan(videonum);
    }
    secondm(){
       var videonum=this.state.videoone[1];
        this.panduan(videonum);
    }
    thirdm(){
        var videonum=this.state.videoone[2];
        this.panduan(videonum);
    }
    fourm(){
        var videonum=this.state.videoone[3];
        this.panduan(videonum);
    }
    fivem(){
        var videonum=this.state.videoone[4];
        this.panduan(videonum);
    }
    sixm(){
        var videonum=this.state.videoone[5];
        this.panduan(videonum);
    }
    sevenm(){
        var videonum=this.state.videoone[6];
        this.panduan(videonum);
    }
    eightm(){
        var videonum=this.state.videoone[7];
        this.panduan(videonum);
    }
    ninem(){
        var videonum=this.state.videoone[8];
        this.panduan(videonum);
    }
    shim(){
       var videonum=this.state.videoone[9];
        this.panduan(videonum);
    }
    shiyim(){
       var videonum=this.state.videoone[10];
        this.panduan(videonum);
    }
    shierm(){
        var videonum=this.state.videoone[11];
        this.panduan(videonum);
    }
    shisanm(){
        var videonum=this.state.videoone[12];
        this.panduan(videonum);
    }
    shisim(){
       var videonum=this.state.videoone[13];
        this.panduan(videonum);
    }
    shiwum(){
        var videonum=this.state.videoone[14];
        this.panduan(videonum);
    }
    shilium(){
        var videonum=this.state.videoone[15];
        this.panduan(videonum);
    }
    shiqim(){
        var videonum=this.state.videoone[16];
        this.panduan(videonum);
    }
    shibam(){
       var videonum=this.state.videoone[17];
        this.panduan(videonum);
    }
    shijium(){
       var videonum=this.state.videoone[18];
        this.panduan(videonum);
    }
    ershim(){
        var videonum=this.state.videoone[19];
        this.panduan(videonum);
    }
    ershiyim(){
        var videonum=this.state.videoone[20];
        this.panduan(videonum);
    }
    ershierm(){
        var videonum=this.state.videoone[21];
        this.panduan(videonum);
    }
    ershisanm(){
        var videonum=this.state.videoone[22];
        this.panduan(videonum);
    }
    closes(){
        var dakehuvideo=document.getElementById('dakehuvideo1');
        dakehuvideo.pause();
        this.setState({
            dakehuonem:'none'
        });
    }
    dakehusixnext(){
        var that=this;
        that.setState({
            dakehusixbac:'url("https://weixun-demo.oss-cn-beijing.aliyuncs.com/dakehu/dakehusixsix.jpg")',
            dakehusixns:'block',
            dakehusis:'none'
        });
    }
    dakehusixback(){
        var that=this;
        that.setState({
            dakehusixbac:'url("https://weixun-demo.oss-cn-beijing.aliyuncs.com/dakehu/dakehusix.jpg")',
            dakehusis:'block',
            dakehusixns:'none'
        });
    }
    componentDidMount() {
        var dakehuvideo = document.getElementById('dakehuvideo1');
        var that=this;
        dakehuvideo.addEventListener('ended', function () {
            for(var i=0;i<that.state.videoone.length;i++){
                if(that.state.videos==that.state.videoone[i]){
                    if(that.state.wancheng.indexOf(i)!=-1){
                        console.log('包含');
                    }else{
                        that.setState({
                            wancheng:that.state.wancheng+i
                        })
                    }
                    console.log(that.state.wancheng);
                }

            }
        });
        dakehuvideo.addEventListener("timeupdate",function(){
            var timeDisplay;
            timeDisplay = Math.floor(dakehuvideo.currentTime);
        },true)
    }
    render(){
        return(
            <div className='dakehusixbac' style={{backgroundImage:this.state.dakehusixbac}}>
                <Link to='dakehu'><div className='dakehutui'></div></Link>
                <div className='dakehusixcourseyi' onClick={this.firstm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseer' onClick={this.secondm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcoursesan' onClick={this.thirdm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcoursesi' onClick={this.fourm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcoursewu' onClick={this.fivem.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseliu' onClick={this.sixm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseqi' onClick={this.sevenm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseba' onClick={this.eightm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcoursejiu' onClick={this.ninem.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseshi' onClick={this.shim.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseshiyi' onClick={this.shiyim.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseshier' onClick={this.shierm.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixnext' onClick={this.dakehusixnext.bind(this)} style={{display:this.state.dakehusis}}></div>
                <div className='dakehusixcourseshisan' onClick={this.shisanm.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshisi' onClick={this.shisim.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshiwu' onClick={this.shiwum.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshiliu' onClick={this.shilium.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshiqi' onClick={this.shiqim.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshiba' onClick={this.shibam.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseshijiu' onClick={this.shijium.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseershi' onClick={this.ershim.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseershiyi' onClick={this.ershiyim.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseershier' onClick={this.ershierm.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixcourseershisan' onClick={this.ershisanm.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehusixback' onClick={this.dakehusixback.bind(this)} style={{display:this.state.dakehusixns}}></div>
                <div className='dakehushenqing' style={{display:this.state.shenqing}} ></div>
                <video className='dakehuvideo1' id='dakehuvideo1'  style={{display:this.state.dakehuonem}} controls='controls'  autoPlay='true' src={this.state.videos}/>
                <div className='dakehuclose' onClick={this.closes.bind(this)} style={{display:this.state.dakehuonem}}>X</div>
            </div>

        )
    }
}

function mapStateToProps({ login}/*默认值加解构数组*/) {

    console.log(login)
    return {
        userInfo: login

    }
}

export default withRouter(connect(mapStateToProps)(Dakehusix));
